import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

// NOTE: The entity behind this DTO is effectively an owned entity, and is not used outside
// of the context of a parent entity. For this reason, it is not necessary to have a separate
// List or Record versions of it or extend it from the BaseDto.

/**
 * Asset unavailability item DTO
 */
export class AssetUnavailabilityItemDto {
	@TransformInt()
	id?: number;
	uuid!: string;
	@TransformDate()
	startsAt!: Date;
	@TransformDate()
	endsAt?: Date;
	reason?: string;
}
